import React from 'react'
import {
  COLUMN_TYPES,
  reducers,
  DATA_TYPES,
  Icon,
  //@ts-ignore no types
} from '@adc/ui-morpheus'
import { COMMUNICATIONS } from '../../constants/tableTypes'

const getDefaultColProps = (width: number) => ({
  width,
  isResizable: true,
  isReorderable: true,
  isVisible: false,
})

export const tableConfig = {
  config: {
    entityKey: COMMUNICATIONS,
    primaryKeyField: 'notification_id',
  },
  fieldDefinitions: [
    {
      name: 'Name',
      apiRef: 'notification_display_name',
      sortAnalyzer: '',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        partialMatch: true,
        colProps: {
          ...getDefaultColProps(300),
          isVisible: true,
          searchable: true,
        },
      },
    },
    {
      name: 'Description',
      apiRef: 'notification_description',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        partialMatch: true,
        colProps: {
          ...getDefaultColProps(300),
          isVisible: true,
          searchable: true,
        },
      },
    },
    {
      name: 'Trigger Description',
      apiRef: 'trigger_description',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        partialMatch: true,
        colProps: {
          ...getDefaultColProps(300),
          isVisible: true,
          searchable: true,
        },
      },
    },
    {
      name: 'Line of Business',
      apiRef: 'asset_type',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        partialMatch: true,
        colProps: {
          ...getDefaultColProps(150),
          isVisible: true,
          searchable: true,
        },
      },
    },
    {
      name: 'Purpose Type',
      apiRef: 'purpose_type',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        partialMatch: true,
        colProps: {
          ...getDefaultColProps(150),
          isVisible: true,
          searchable: true,
        },
      },
    },
    {
      name: 'Channel',
      apiRef: 'channel',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        partialMatch: true,
        colProps: {
          ...getDefaultColProps(150),
          isVisible: true,
          searchable: true,
        },
      },
    },
    {
      name: 'Is active',
      apiRef: 'active',
      columnDefinition: {
        dataType: DATA_TYPES.BOOLEAN,
        type: COLUMN_TYPES.BOOL,
        colProps: {
          ...getDefaultColProps(100),
          isVisible: true,
          searchable: true,
        },
      },
    },
    {
      name: 'Actions',
      apiRef: '__actions__', // not api val
      columnDefinition: {
        type: COLUMN_TYPES.ACTION,
        actions: ['Link'],
        colProps: { width: 80, fixedRight: true, align: 'center' },
      },
    },
  ],
  filterClauses: [],
  sortBy: [
    {
      field: 'notification_display_name',
      order: 'asc',
    },
  ],
}

const columnAction =
  (actionCellActionType: string) =>
  (
    actionIndex: number,
    rowIndex: number,
    _primaryId: number,
    data: unknown,
    onRowAction: (actionType: string, rowIndex: number, data: unknown) => void
  ) =>
    (
      <Icon
        color='info'
        size='large'
        style={{ marginTop: -3, cursor: 'pointer' }}
        name='eye'
        key={actionIndex}
        title='View Metrics'
        data-elm-id={`action_edit_${rowIndex}`}
        onClick={() => onRowAction(actionCellActionType, rowIndex, data)}
      />
    )

export const columnSelector = (state: any) =>
  state.fieldDefinitions
    .filter((field: any) => field.columnDefinition)
    .map((col: any) => {
      const column = {
        ...col.columnDefinition,
        ...{ field: col.apiRef, title: col.name },
      }
      if (column.actions) column.actions = column.actions.map(columnAction)
      if (col.dataType) column.dataType = col.dataType
      if (col.searchType) column.searchType = col.searchType
      if (col.options) column.options = col.options
      if (col.formatOptions) column.formatOptions = col.formatOptions
      return column
    })

export default reducers.dataTable.dataTable(COMMUNICATIONS, tableConfig)
